<tiime-dialog [isLoading]="isLoading()" (cancel)="cancel()">
  <span mat-dialog-title>{{ title }}</span>
  <mat-dialog-content mat-dialog-content>
    @if (instruction) {
      <p data-cy="instruction" [innerHtml]="instruction"></p>
    }
    <div tiimeFormColumn>
      <tiime-input-container
        contentId="startDate"
        [label]="startDatePlaceholder"
        [errorMessage]="form.accountingPeriodErrorMessage?.message"
      >
        <tiime-select
          id="startDate"
          class="selected"
          [formControl]="form.accountingPeriod"
          [customFindOriginValueFromOptions]="compareAccountingPeriodFn"
        >
          <div tiimeSelectOptions>
            @for (accountingPeriod of accountingPeriods(); track accountingPeriod.id) {
              <mat-option [value]="accountingPeriod">
                <div class="accouting-period-option">
                  {{ accountingPeriod.startDate | date: 'shortDate' }}
                  @if (accountingPeriod.custom) {
                    <mat-icon fontSet="fontastic" fontIcon="icon-calendar" inline="true"></mat-icon>
                  }
                </div>
              </mat-option>
            }
          </div>
        </tiime-select>
      </tiime-input-container>
      @if (form.accountingPeriod.value) {
        <tiime-input-container
          contentId="endDate"
          [label]="endDatePlaceholder"
          [errorMessage]="form.endDateErrorMessage?.message"
        >
          <input
            id="endDate"
            [placeholder]="endDatePlaceholder"
            type="text"
            [min]="form.accountingPeriod.value.startDate | map: mapToMinDate"
            [max]="form.accountingPeriod.value.endDate | map: mapToMaxDate"
            [formControl]="form.endDate"
            [matDatepicker]="endDatePicker"
            autocomplete="off"
          />
          <mat-datepicker panelClass="tiime-material-datepicker" #endDatePicker></mat-datepicker>
        </tiime-input-container>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button [disabled]="isLoading()" type="button" tiime-button color="accent" strocked large (click)="cancel()">
      Annuler
    </button>
    <button [disabled]="isLoading()" type="submit" tiime-button color="accent" large raised (click)="validate()">
      Valider
    </button>
  </mat-dialog-actions>
</tiime-dialog>
